// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e6galz {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 32px 24px;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  min-height: 200px;
}

.OLgLeY {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 544px;
  gap: 24px;
}

.Yu0ZP4 {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 4px;
}

.ArVemK {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.42em;
  color: #1f1f1f;
  margin: 0;
  text-align: center;
}

.CbUlgg {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: var(--spacing-1);
  width: 100%;
}

.oCaKm8 {
  font-family: var(--font-family-base);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  font-size: var(--type-paragraph-md-font-size);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  height: 28px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/SupportPage/SupportPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,iEAAiE;EACjE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,6CAA6C;EAC7C,yDAAyD;EACzD,+BAA+B;EAC/B,SAAS;EACT,YAAY;AACd","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 32px 24px;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  min-height: 200px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 544px;\n  gap: 24px;\n}\n\n.titleSection {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: 4px;\n}\n\n.pageTitle {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.42em;\n  color: #1f1f1f;\n  margin: 0;\n  text-align: center;\n}\n\n.carouselSection {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: var(--spacing-1);\n  width: 100%;\n}\n\n.carouselTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  font-size: var(--type-paragraph-md-font-size);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  height: 28px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `e6galz`,
	"content": `OLgLeY`,
	"titleSection": `Yu0ZP4`,
	"pageTitle": `ArVemK`,
	"carouselSection": `CbUlgg`,
	"carouselTitle": `oCaKm8`
};
module.exports = ___CSS_LOADER_EXPORT___;
